import script from "./ModelFilters.vue?vue&type=script&setup=true&lang=js"
export * from "./ModelFilters.vue?vue&type=script&setup=true&lang=js"

import "./ModelFilters.vue?vue&type=style&index=0&id=3494dc57&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3494dc57"]])

export default __exports__